'use client';
import React, { useState } from 'react';
import { Toaster, toast } from 'sonner';
import ExerciseGrid from './ExerciseGrid';
import ExerciseDetail from './ExerciseDetail';
import { EXERCISES } from './practiceData';
import type { Exercise } from './practiceData';

export default function PracticeClient() {
  const [exercises, setExercises] = useState<Exercise[]>(EXERCISES);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const selectedExercise = exercises.find((e) => e.id === selectedId) ?? null;

  const handleSelect = (id: string) => {
    setSelectedId(id);
    setExercises((prev) =>
      prev.map((e) =>
        e.id === id && e.status === 'not-started'
          ? { ...e, status: 'in-progress' }
          : e
      )
    );
  };

  const handleBack = () => setSelectedId(null);

  const handleComplete = (id: string) => {
    setExercises((prev) =>
      prev.map((e) => (e.id === id ? { ...e, status: 'completed' } : e))
    );
    toast.success('Exercise completed! Well done.', {
      description: 'Your circuit matches the correct wiring for this exercise.',
    });
  };

  const handleFail = (id: string) => {
    setExercises((prev) =>
      prev.map((e) => (e.id === id ? { ...e, status: 'failed' } : e))
    );
    toast.error('Circuit not quite right.', {
      description: 'Review the faults listed and try again.',
    });
  };

  const handleReset = (id: string) => {
    setExercises((prev) =>
      prev.map((e) =>
        e.id === id
          ? { ...e, status: 'in-progress', steps: e.steps.map((s) => ({ ...s, completed: false })) }
          : e
      )
    );
  };

  return (
    <div className="flex h-full overflow-hidden bg-slate-50">
      <Toaster position="bottom-right" richColors />
      {selectedExercise ? (
        <ExerciseDetail
          exercise={selectedExercise}
          onBack={handleBack}
          onComplete={handleComplete}
          onFail={handleFail}
          onReset={handleReset}
        />
      ) : (
        <ExerciseGrid exercises={exercises} onSelect={handleSelect} />
      )}
    </div>
  );
}